module.exports = __webpack_public_path__ + "media/images/screenshots/data-focus-9ed89444dc628938d06edb7ab7587b17.png";